import { CommentAction, CommentActions } from '../actions/comment.actions';
import { WithdrawCommentPayload } from '../models/withdraw-comment.model';
import { WithdrawCommentState } from '../state/withdraw-comment.state';

export const initialWithdrawCommentState: WithdrawCommentState = {
    comments: [],
};

export function WithdrawCommentReducer(
    state = initialWithdrawCommentState,
    action: CommentAction
) {
    switch (action.type) {
        case CommentActions.GetWithdrawCommentsSuccess:
            return {
                ...state,
                comments: (action as { payload: WithdrawCommentPayload })?.payload?.data,
            };
        default:
            return state;
    }
}
